import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

const propTypes = {
    /**
   * An indeterminate checkbox means that its state is unclear.
   * Typically, this is used when the checkbox has some sub-options under it.
   */ indeterminate: PropTypes.bool,
    /**
   * If set to true, the checkbox will animate instantly.
   */ instant: PropTypes.bool,
    /**
   * The visual style of the Checkbox.
   * One of: "standard", "favourite".
   */ skin: PropTypes.oneOf([
        'standard',
        'favorite'
    ])
};
const propKeysToRemove = Object.keys(propTypes);
const Checkbox = renderWithRef('Checkbox', propTypes, (props, ref)=>{
    const { instant = false, skin = 'standard' } = props;
    const classNames = new Set([
        'swan-checkbox'
    ]);
    if (skin == 'favorite') {
        classNames.add('swan-checkbox-skin-favorite');
    }
    if (instant) {
        classNames.add('swan-checkbox-instant');
    }
    const inputRef = React.useRef();
    const finalRef = assignRefs(inputRef, ref);
    React.useEffect(()=>{
        if (inputRef.current) {
            inputRef.current.indeterminate = !!props.indeterminate;
        }
    }, [
        props.indeterminate
    ]);
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "input",
        forwardedRef: finalRef,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: props
    }, props.children);
});
Checkbox.defaultProps = {
    type: 'checkbox',
    instant: false,
    skin: 'standard'
};

export { Checkbox };
